import { BASE_URL } from '../../constants';
import { useNavigate } from 'react-router-dom';
import { getSiteId } from '../../Utils/helper';
const Help = () => {
    const navigate = useNavigate();
    const bannerStyle = {
        backgroundImage: `url(${BASE_URL}/assets/images/home_Bg_orange.png)`,
      };

    const itemBoxStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/etiqueta_whiteBg.png)`,
    };
    const navigateToHome = async () => {
        navigate(-1);
        /*localStorage.removeItem('booking_reference_id');
        localStorage.removeItem('bookingData');
        navigate("/" + getSiteId());*/
    }
  return ( 
    <div>
        <div className="wrapper">
            <div className="ayuda_bannerArea" style={bannerStyle}>
                <div className="logo sm_logo">
                    <a href="#" onClick={navigateToHome}>
                        <img src={`${BASE_URL}/assets/images/logo.png`} alt=""/>
                        </a>
                </div>
                <div className="main_ayudaContant">
                    <div className="itemBox">
                        <div className="bnr_heading" style={itemBoxStyle}>
                            <h2>¡En un momento <br/>
                                un anfitrión <br/>
                                te ayudará!
                            </h2>
                        </div>
                        <div className="imageBg">
                            <img src={`${BASE_URL}/assets/images/charactersBg.png`} alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>);
};

export default Help;
